import com from '../../../../../comMapping.js'
export function getdata() {
	let obj = {	
    headData: [{
      title: '赋码次序',
      prop: 'num',
      width: '200',
      custom:true,
    },
    {
      title: '操作类型',
      prop: 'operatingType',
      width: '120',
      custom:true,
    },
    {
      title: '发票类型',
      prop: 'invoiceType',
      width: '120',
      showFilter: true,
      custom: true,
      checkList: com.lqfplx.map(item => item.code),
      dataList: com.lqfplx
    },
    {
      title: '单据号',
      prop: 'docNo',
      width: '200',
      issort: true,
    },
    {
      title: '单据状态',
      prop: 'docStatus',
      width: '120',
      showFilter: true,
      custom: true,
      checkList: com.lqdjzt.map(item => item.code),
      dataList: com.lqdjzt
    },
    {
      title: '开票时间',
      prop: 'drawDate',
      width: '220',
      showFilter: true,
			custom: true,
      issort: true,
    },
    {
      title: '价税合计',
      prop: 'totalTax',
      width: '180',
      AmountFormat: true,
      align: "right"
    },
    {
      title: '操作人',
      prop: 'operator',
      width: '120',
    },{
      title: '操作时间',
      prop: 'createTime',
      width: '120',
    },
  ],
  //页码
  pagination: {
    pageNum: 1,
    pageSize: 10,
    total: 1,
    paginationkey: 0
  },
  }
	return obj
}
